import invariant from 'tiny-invariant'

import useAppSelector from '@/hooks/useAppSelector'
import { selectCurrentCompany } from '@/redux/slices/session'

function useCurrentCompanyOrFail() {
  const currentCompany = useAppSelector(selectCurrentCompany)

  invariant(
    currentCompany,
    'Used useCurrentCompany in a place where user is not authenticated',
  )

  return currentCompany
}

export default useCurrentCompanyOrFail
